import { render, staticRenderFns } from "./ChatTabDetails.vue?vue&type=template&id=1b60e817&"
import script from "./ChatTabDetails.vue?vue&type=script&lang=ts&"
export * from "./ChatTabDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports